export function Icon({ name, className = "icon", title }: { readonly name: string; readonly className?: string; readonly title?: string }) {
  return (
    <svg className={className} aria-hidden={title ? undefined : true} role={title ? "img" : undefined}>
      {title ? <title>{title}</title> : null}
      <use href={`/assets/icons/ui-sprite.svg#${name}`} />
    </svg>
  );
}
